/**
 * @generated SignedSource<<8bd499c2349ff316bc136e20d1461aab>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CloudProvider = "AWS" | "Anthropic" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type IdentityProviderType = "AWS" | "Azure" | "GCP" | "SAML" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useIdentityProviderSources_query$data = {
  readonly cloudOrganizations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly idpAlias: string | null | undefined;
        readonly idpNamespace: string;
        readonly idpType: IdentityProviderType;
        readonly key: string;
        readonly name: string;
        readonly provider: CloudProvider;
      };
    }> | null | undefined;
  };
  readonly samlProviders: ReadonlyArray<{
    readonly displayName: string | null | undefined;
    readonly id: string;
    readonly idpAlias: string | null | undefined;
    readonly idpNamespace: string;
    readonly idpType: IdentityProviderType;
    readonly name: string;
  }>;
  readonly " $fragmentType": "useIdentityProviderSources_query";
};
export type useIdentityProviderSources_query$key = {
  readonly " $data"?: useIdentityProviderSources_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIdentityProviderSources_query">;
};

import useIdentityProviderSourcesRefetchQuery_graphql from './useIdentityProviderSourcesRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "cloudOrganizations"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpAlias",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpNamespace",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": useIdentityProviderSourcesRefetchQuery_graphql
    }
  },
  "name": "useIdentityProviderSources_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SAMLProvider",
      "kind": "LinkedField",
      "name": "samlProviders",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        (v4/*:: as any*/),
        (v5/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "cloudOrganizations",
      "args": null,
      "concreteType": "CloudOrganizationConnection",
      "kind": "LinkedField",
      "name": "__useIdentityProviderSources_cloudOrganizations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CloudOrganizationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CloudOrganization",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                (v2/*:: as any*/),
                (v3/*:: as any*/),
                (v4/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                (v5/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "provider",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cad88148e856c897114b40fc3c3be184";

export default node;
